module.exports = __webpack_public_path__ + "static/media/social-inst.6a1b12f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social-inst.svg
// module id = 323
// module chunks = 0